import { createReducer } from "../../../_common/common";
import {
    SET_INFORMATIVE_SESSION,
    SET_INFORMATIVE_SESSIONS,
    SET_PAST_SESSION,
    SET_REMINDER_SESSION,
    SET_SESSION_URL,
} from "../actions/constants";

const initialState = {
    informativeSessions: [],  // Lista de próximas sesiones informativas
    informativeSession: null, // Detalle de una sesión específica
    pastSessions: [],         // Lista de sesiones pasadas
    reminder: null,           // Recordatorio creado para una sesión
    sessionURL: null,         // URL de la sesión
};

export const informativeSessionReducer = createReducer(initialState, {
    [SET_INFORMATIVE_SESSIONS]: (state, payload) => ({
        ...state,
        informativeSessions: payload,
    }),
    [SET_INFORMATIVE_SESSION]: (state, payload) => ({
        ...state,
        informativeSession: payload,
    }),
    [SET_PAST_SESSION]: (state, payload) => ({
        ...state,
        pastSessions: payload,
    }),
    [SET_REMINDER_SESSION]: (state, payload) => ({
        ...state,
        reminder: payload,
    }),
    [SET_SESSION_URL]: (state, payload) => ({
        ...state,
        sessionURL: payload,
    }),
});
